function InspectModalController(CommonService, stateService, $timeout) {
  const ctrl = this;
  const preLoadStream = CommonService.preLoadStream;
  const getMacroList = CommonService.getMacroList;

  ctrl.$onInit = () => {
    ctrl.trigger = ctrl.resolve.trigger;
    ctrl.workspaceId = stateService.getSelectedWorkspace().id;
    if (ctrl.trigger.trigger) {
      ctrl.streams = ctrl.trigger.trigger.streams;
    } else {
      ctrl.streams = ctrl.trigger.streams;
    }
    getFileUrls(ctrl.streams);
  };

  const getFileUrls = async (streams) => {
    if (!streams) return;
    ctrl.fetchDone = false;
    const macroList = await getMacroList(ctrl.workspaceId);
    streams.map(s => {
      if (s.id !== null) {
        preLoadStream(ctrl.workspaceId, s, macroList).then(fileUrl => {
          s.file_url = fileUrl;
          $timeout(() => {
            ctrl.fetchDone = true;
          }, 100);
        });
      }
    });
  };

  ctrl.selectTrigger = ($event, trigger) => {
    $event.preventDefault();
    $event.stopPropagation();
    if (ctrl.selectedTrigger === trigger) {
      ctrl.selectedTrigger = null;
    } else {
      ctrl.selectedTrigger = trigger;
    }
  };

  ctrl.submit = () => {
    ctrl.close({ $value: ctrl.selectedTrigger });
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('pis-tool.module')
  .controller('InspectModalController', InspectModalController);
